import type { FormSortIndividualNormalized } from '@/types/forms';
import type { SalesforceProduct } from '@/types/salesforce';
import type { ProductConfiguration } from '../config/ProductConfig';
import { PRODUCT_CONFIG } from '../config/ProductConfig';
import { AgeCalculatorService } from './AgeCalculatorService';

export class ProductSelectorService {
  private membersNormalized: FormSortIndividualNormalized[];
  private productConfig: ProductConfiguration;

  constructor(
    membersNormalized: FormSortIndividualNormalized[],
    productConfig: typeof PRODUCT_CONFIG = PRODUCT_CONFIG
  ) {
    this.membersNormalized = membersNormalized;
    this.productConfig = productConfig;
  }

  getSelectedProduct(): SalesforceProduct {
    let allUnder45 = true;
    let anyOver60 = false;

    for (const individual of this.membersNormalized) {
      if (AgeCalculatorService.isOver60(new Date(individual.dateOfBirth))) {
        anyOver60 = true;
        break;
      }

      if (!AgeCalculatorService.isUnder45(new Date(individual.dateOfBirth))) {
        allUnder45 = false;
      }
    }

    // Product selection logic
    if (anyOver60) return this.productConfig.products.over60;

    if (allUnder45) {
      return this.productConfig.products.under45;
    }

    // Default to signature for mixed age families
    return this.productConfig.products.signature;
  }
}
